var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVessel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 4,
    fill: "#678DFF",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7917 28.4823C42.5073 28.7962 43.0956 29.3447 43.4605 30.038C43.8253 30.7313 43.945 31.5284 43.8 32.299L43.1195 35.399C42.6226 38.0306 41.2055 40.3973 39.1238 42.072C37.0421 43.7468 34.433 44.6193 31.767 44.5323H23.8667C21.2008 44.6193 18.5916 43.7468 16.51 42.072C14.4283 40.3973 13.0112 38.0306 12.5142 35.399L11.8338 32.299C11.6888 31.5284 11.8085 30.7313 12.1733 30.038C12.5381 29.3447 13.1264 28.7962 13.842 28.4823L16.1988 27.5323L25.3439 23.849C26.9322 23.2156 28.7015 23.2156 30.2899 23.849L39.4349 27.5323L41.7917 28.4823Z",
    stroke: "#272727",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8167 44.5327V24.5327",
    stroke: "#272727",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4347 21.1994V27.5328L30.2896 23.8494C28.7013 23.216 26.932 23.216 25.3437 23.8494L16.1986 27.5328V21.1994C16.2025 19.8746 16.7284 18.6051 17.6613 17.6683C18.5942 16.7314 19.8584 16.2034 21.1778 16.1994H34.4556C35.7749 16.2034 37.0391 16.7314 37.972 17.6683C38.9049 18.6051 39.4308 19.8746 39.4347 21.1994V21.1994Z",
    stroke: "#272727",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.966 16.1994H23.6674V12.8661C23.6674 12.4241 23.8422 12.0001 24.1535 11.6876C24.4647 11.375 24.8869 11.1994 25.3271 11.1994H30.3062C30.7464 11.1994 31.1686 11.375 31.4798 11.6876C31.7911 12.0001 31.966 12.4241 31.966 12.8661V16.1994Z",
    stroke: "#272727",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVessel);
export default __webpack_public_path__ + "static/media/vessel.c11e9ade018d73fb9839131dd8cf4564.svg";
export { ForwardRef as ReactComponent };